export const normalizeDocumentNumber = (value) => {
  if (!value) return value;
  const trimmedValue = value.trim();
  const rutPattern = /^[0-9.]+(-[0-9Kk])?$/;
  const isNumericDocument = /^[0-9]+$/.test(trimmedValue.replace(/[.-]/g, '')) || 
                           /^[0-9]+[Kk]$/.test(trimmedValue.replace(/[.-]/g, ''));
  
  if (rutPattern.test(trimmedValue) || isNumericDocument) {
    return trimmedValue.split('-')[0].replace(/\./g, '')
  }
  
  return trimmedValue;
};